import { BaseTemplate } from "./BaseTemplate";
const BACKDROP_CLASS = "connext-modal-backdrop";
const MODAL_SCROLLABLE_CLASS = "modal-scrollable";
const PAGE_OVERFLOW_CLASS = "page-overflow";
const MODAL_OVERFLOW_CLASS = "modal-overflow";
const DEFAULT_BACKDROP_OPACITY = 0.7;
export class ModalTemplate extends BaseTemplate {
    constructor(action) {
        super(action);
    }
    render() {
        this.createBackdrop();
        this.createModal();
        this.handleScrollBehavior();
        this.mountToBody();
        this.applyUserState();
        this.applyTransitionIn();
        this.setupCloseHandler(() => this.teardown());
        this.setupBackdropClose();
    }
    createBackdrop() {
        // reuse existing backdrop if already present — mirrors ConnextV2 ModalBackDrop behaviour
        const existing = document.querySelector(`.${BACKDROP_CLASS}`);
        if (existing) {
            this.backdrop = existing;
            return;
        }
        this.backdrop = document.createElement("div");
        this.backdrop.className = `${BACKDROP_CLASS} fade`;
        const opacity = this.getBackdropOpacity();
        this.backdrop.style.opacity = String(opacity);
        document.body.appendChild(this.backdrop);
    }
    getBackdropOpacity() {
        var _a, _b, _c, _d, _e;
        const val = (_c = (_b = (_a = this.action) === null || _a === void 0 ? void 0 : _a.showWhat) === null || _b === void 0 ? void 0 : _b.BackdropOpacity) !== null && _c !== void 0 ? _c : (_e = (_d = this.action) === null || _d === void 0 ? void 0 : _d.showWhat) === null || _e === void 0 ? void 0 : _e.TransparentBackdrop;
        if (typeof val === "number") {
            return Math.max(0, Math.min(1, val));
        }
        return DEFAULT_BACKDROP_OPACITY;
    }
    createModal() {
        // mirrors ConneXt v2 BSModal.createContainer() — modal-scrollable wrapper
        this.container.classList.add(MODAL_SCROLLABLE_CLASS);
        this.container.innerHTML = this.getProcessedHtml();
        // innerHTML does not execute <script> tags. Re-create them so the browser runs them.
        // Mirrors Connext v2 behaviour where Bootstrap/jQuery evaluates inline scripts.
        this.executeScripts(this.container);
        this.applyDataWidths();
    }
    applyDataWidths() {
        this.container.querySelectorAll("[data-width]").forEach((el) => {
            const width = el.getAttribute("data-width");
            if (width && !isNaN(Number(width))) {
                el.style.width = `${width}px`;
            }
        });
    }
    handleScrollBehavior() {
        var _a, _b;
        // mirrors ConneXt v2 ModalScrollBar — add page-overflow when modal taller than viewport
        // Also respects Scrollable: false from ShowWhat (explicit scroll lock)
        const scrollable = (_b = (_a = this.action) === null || _a === void 0 ? void 0 : _a.showWhat) === null || _b === void 0 ? void 0 : _b.Scrollable;
        if (scrollable === false) {
            // explicit scroll lock requested
            document.body.classList.add(PAGE_OVERFLOW_CLASS);
            document.body.style.overflow = "hidden";
            return;
        }
        // auto-detect: lock scroll if modal content exceeds viewport height
        requestAnimationFrame(() => {
            const modalEl = this.container.querySelector(".modal");
            if (!modalEl)
                return;
            const clientHeight = document.documentElement.clientHeight;
            const modalHeight = modalEl.clientHeight;
            if (clientHeight < modalHeight) {
                document.body.classList.add(PAGE_OVERFLOW_CLASS);
                modalEl.classList.add(MODAL_OVERFLOW_CLASS);
            }
        });
    }
    setupBackdropClose() {
        var _a, _b, _c, _d, _e, _f, _g;
        const notClosable = (_b = (_a = this.action) === null || _a === void 0 ? void 0 : _a.showWhat) === null || _b === void 0 ? void 0 : _b.NotClosable;
        const ignoreBackdropClick = (_d = (_c = this.action) === null || _c === void 0 ? void 0 : _c.showWhat) === null || _d === void 0 ? void 0 : _d.ignoreBackdropClick;
        const modalOutsideClose = (_g = (_f = (_e = this.action) === null || _e === void 0 ? void 0 : _e.showWhat) === null || _f === void 0 ? void 0 : _f.ModalOutsideClose) !== null && _g !== void 0 ? _g : true;
        // mirrors ConneXt v2: don't close if notClosable, ignoreBackdropClick, or ModalOutsideClose is false
        if (notClosable || ignoreBackdropClick || !modalOutsideClose)
            return;
        this.backdrop.addEventListener("click", () => {
            this.applyTransitionOut(() => this.teardown());
        });
    }
    teardown() {
        this.container.remove();
        // only remove backdrop if no other modals remain in the DOM
        const remainingModals = document.querySelectorAll(`.${MODAL_SCROLLABLE_CLASS}`);
        if (remainingModals.length === 0) {
            this.backdrop.remove();
            this.restoreScroll();
        }
    }
    restoreScroll() {
        document.body.classList.remove(PAGE_OVERFLOW_CLASS);
        document.body.style.overflow = "";
        // also remove modal-overflow from any remaining modal elements
        document.querySelectorAll(`.${MODAL_OVERFLOW_CLASS}`)
            .forEach(el => el.classList.remove(MODAL_OVERFLOW_CLASS));
    }
}
